import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRemoveKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"remove-keyframe, rhombus"} maskId="square-filled-radius-0-stroke-1-IconRemoveKeyframe"><path fillRule="evenodd" clipRule="evenodd" d="M1.29297 12L12.0001 1.29297L22.7072 12L12.0001 22.7072L1.29297 12ZM8.5 11.5V12.5H15.5V11.5H8.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconRemoveKeyframe;
